import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const documentcheck: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M6.4956,4.5 L6.4996,19.5 L17.4996,19.5 L17.4976,9.494 L12.4996,4.5 L6.4956,4.5 Z M8,13.5 L11,13.5 M8,16.5 L11,16.5 M12,13 L13,14 L16,11 M12,16 L13,17 L16,14 M12.5,4.5 L12.5,9.5 L17.498,9.494"
      />
    </svg>
  );
};
